const Jobs = (()=>{
	const intersectionAnimation = () => {
		const sectionReveals = document.querySelectorAll('.secReveals')
		const getPageJobs = document.querySelector('.page-jobs');
		let pathN = window.location.pathname
		let pathNMo = pathN.slice(1)
		const callback = (entries, observer) => {
			entries.forEach((entry) => {
				if(getPageJobs){
					if (entry.isIntersecting) {
						let titles = entry.target
						let titlesAn = titles?.querySelectorAll('.headline')
						titlesAn.forEach(tl => {
							tl?.classList.add("set")
						})
						entry.target.classList.add("reveal")
					}else{
						entry.target.classList.remove("reveal")
					}
				}
			})
		}
		const options = {
			root: null,
			rootMargin: '0px',
			threshold: 0.5
		}
	
		const myObserver = new IntersectionObserver(callback, options)
		sectionReveals.forEach(section => {
			myObserver.observe(section)
		})
	}

	return { 
		childsJobs : function(){
			try{changeBackgroundPage()}catch(err){ }
			try{intersectionAnimation()}catch(err){ }
		}
	}

})();

const getChildsJobs = ()=>{
	Jobs.childsJobs();
}

export { getChildsJobs }